var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthenticationFlatline2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 328 273",
    style: {
      enableBackground: "new 0 0 328 273"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FAF1E4;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#EBCA94;}\r\n\t.st4{fill:#E6E7E8;}\r\n\t.st5{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_013"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.4,257.2c-19.4,1-38.6,7.8-58,6.5c-36.2-2.5-65.9-34.3-74.2-69.8c-4.3-18.4-3.5-38.8,7.2-54.3 c4-5.7,9.1-10.6,13.1-16.2c13-18.1,13.8-42.7,25.9-61.4C67.5,40.2,94,30.3,119.1,23.7c14.8-3.8,29.7-7,44.7-9.5 c22.5-3.7,47.5-5.3,66.1,8c13.9,9.9,21.5,26.3,31,40.3c12.7,18.7,29.8,34,43.2,52.1c15.3,20.5,19.8,40,17.4,61.2l-0.2,1.8 c-1.4,9.6-3.8,18.9-7.2,28.1c-10.3,28.5-33.1,53.7-63.5,60.3C214,274.3,176.7,255.3,139.4,257.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,215.8c-18.4-9.1-38.1-15.5-58.3-19.2c10.4-6.9,11-24.6,12.7-37c5.6-39.8,45.1-65.2,75.8-86.1 c2.5-1.8,5.3-3.5,8-5.1c3.3-1.7,12.3-7.1,14.7-2.1c2.2,4.8-3.4,13.5-6.2,17.1c1.8-2.7,4-5.4,6.2-7.9c0.7-0.9,1.6-1.6,2.7-1.9 c2-0.5,4.1,1.5,4.4,3.6c0.3,2.1-0.5,4.2-1.5,6c-2.2,4.5-5.2,8.8-8.5,12.5c2.2-2.5,10.6-12.1,10.4-2.4c-0.1,6.1-2.6,11.9-7.1,16.1 c1.9-1.7,4-3.2,6.2-4.5c0.6-0.5,1.4-0.7,2.2-0.6c0.8,0.4,1.4,1.2,1.5,2.1c1.4,6.2-2,10.7-4.4,16c-1.8,4.2-3,8-5.3,12 c-8.5,14.4-17.5,28.6-27.2,42.2C142,180,118.2,215.9,118.1,215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.1,216.3c-0.1,0-0.1,0-0.2-0.1l0,0c-18.4-9.1-38-15.5-58.1-19.1c-0.3-0.1-0.5-0.3-0.4-0.6 c0-0.1,0.1-0.2,0.2-0.3c8.8-5.8,10.5-19.9,11.8-31.2c0.2-1.9,0.4-3.8,0.7-5.5c5.4-38.5,42.6-63.7,72.3-84l3.6-2.4 c2.5-1.8,5.3-3.6,8-5.1l0.7-0.4c3.1-1.6,8.8-4.8,12.3-3.7c1,0.3,1.9,1.1,2.3,2c1.2,2.5,0.4,6.1-1.1,9.3c0.1-0.1,0.1-0.2,0.2-0.2 c0.8-1,1.8-1.7,3.1-2.1c1-0.2,2,0,2.9,0.6c1.1,0.8,1.9,2,2.1,3.4c0.3,2.2-0.5,4.4-1.5,6.3c-1.1,2.2-2.4,4.5-3.9,6.6 c1.5-1.1,3-1.7,4.2-1.3c1.2,0.4,1.7,1.9,1.7,4.6c-0.1,4.5-1.5,9-4,12.6c0.8-0.5,1.5-1,2.3-1.5c0.7-0.6,1.7-0.8,2.6-0.6 c1,0.4,1.7,1.4,1.8,2.5c1.1,5.1-0.8,9-2.9,13c-0.5,1-1,2.1-1.5,3.3c-0.6,1.4-1.2,2.9-1.7,4.3c-0.9,2.6-2.1,5.3-3.6,7.7 c-9,15.6-18,29.4-27,42.2c-1.2,1.7-7.6,11.4-13.8,20.7l-8.7,12.9C119,215.5,118.4,216.3,118.1,216.3z M61.1,196.4 c19.7,3.8,38.8,10.1,56.8,18.8c1.2-1.7,6.8-10.2,12.2-18.3c6.2-9.3,12.6-18.9,13.8-20.7c9.1-12.7,17.9-26.6,27.1-42.2 c1.3-2.4,2.5-5,3.5-7.6c0.5-1.4,1.1-2.9,1.7-4.3c0.5-1.1,1-2.2,1.6-3.3c2-4,3.9-7.6,2.9-12.4c-0.2-0.7-0.5-1.5-1.1-1.7 c-0.6-0.1-1.3,0.1-1.8,0.5c-2.1,1.3-4.2,2.7-6.1,4.5c-0.2,0.2-0.5,0.1-0.7-0.1s-0.1-0.5,0-0.7c4.3-4.2,6.8-9.8,6.9-15.8 c0-2-0.3-3.4-1-3.7c-1.3-0.5-4.2,1.6-8.3,6.3l-0.1,0.1c-0.2,0.2-0.5,0.2-0.7,0l0,0c-0.2-0.2-0.2-0.5,0-0.7l0,0l0,0 c3.4-3.8,6.1-7.9,8.5-12.4c0.9-1.8,1.7-3.8,1.4-5.7c-0.2-1.1-0.8-2-1.7-2.7c-0.6-0.4-1.3-0.6-2-0.4c-1,0.3-1.8,1-2.4,1.8 c-1.3,1.4-2.5,3-3.8,4.5c-1.2,1.9-2.3,3.3-2.4,3.4c-0.2,0.2-0.5,0.2-0.7,0.1c-0.2-0.2-0.3-0.5-0.1-0.7c0.8-1.2,1.6-2.3,2.5-3.6 c2.6-4.2,5.2-9.7,3.7-13c-0.3-0.7-1-1.3-1.7-1.5c-3.1-1-8.8,2-11.5,3.6l-0.7,0.4c-2.7,1.5-5.4,3.3-7.9,5.1l-3.6,2.4 c-29.6,20.2-66.6,45.3-71.9,83.3c-0.2,1.7-0.5,3.6-0.7,5.4C71,176.2,69.4,189.8,61.1,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77,20.6l69.9-17.2c2.9-0.7,5.7,1,6.4,3.9l36.9,149.6c0.7,2.9-1,5.7-3.9,6.4l-69.9,17.2 c-2.9,0.7-5.7-1-6.4-3.9L73.1,26.9C72.4,24.2,74.1,21.3,77,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115,181.1c-1,0-2-0.3-3-0.8c-1.3-0.8-2.2-2-2.6-3.6L72.6,27.1c-0.7-3.1,1.1-6.2,4.3-7l69.8-17.2 c3.1-0.7,6.2,1.1,7,4.3l36.9,149.6c0.7,3.1-1.1,6.2-4.3,7L116.4,181C116,181,115.4,181.1,115,181.1z M148.1,3.7 c-0.4,0-0.8,0-1.1,0.1L77.1,21c-2.5,0.6-4.1,3.2-3.5,5.7l36.9,149.6c0.6,2.5,3.2,4.1,5.7,3.5l69.9-17.2l0,0 c2.5-0.6,4.1-3.2,3.5-5.7L152.7,7.4C152.2,5.3,150.4,3.7,148.1,3.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 24.6,
    transform: "matrix(0.971 -0.239 0.239 0.971 -17.2395 33.752)",
    className: "st3",
    width: 73.9,
    height: 126.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.4,157.1l13.6-3.4c1.7-0.4,3.5,0.6,3.9,2.3l1.3,5.2c0.4,1.7-0.6,3.5-2.3,3.9l-13.6,3.4 c-1.7,0.4-3.5-0.6-3.9-2.3l-1.3-5.2C137.5,159.3,138.7,157.5,140.4,157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.4,169.2c-1.7,0-3.3-1.2-3.7-2.9l-1.3-5.2c-0.5-2,0.8-4,2.7-4.5l13.6-3.4c2-0.5,4.1,0.7,4.6,2.7l1.3,5.2 c0.5,2-0.7,4.1-2.7,4.6l0,0l-13.6,3.4C143,169.2,142.7,169.2,142.4,169.2z M154.8,154.1c-0.2,0-0.4,0-0.6,0.1l-13.6,3.4 c-0.7,0.2-1.3,0.6-1.6,1.2c-0.4,0.6-0.5,1.3-0.3,2l1.3,5.2c0.4,1.4,1.8,2.3,3.3,2l0,0l13.6-3.4c1.4-0.4,2.3-1.8,2-3.3l0,0l-1.3-5.2 c-0.2-0.7-0.6-1.3-1.2-1.6C155.8,154.3,155.4,154.1,154.8,154.1L154.8,154.1z M156.9,165.2L156.9,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.5,22.7c-0.2,0-0.4-0.2-0.5-0.4c-0.1-0.3,0.1-0.5,0.4-0.6l0,0l20.5-5c0.3-0.1,0.5,0.1,0.6,0.4l0,0 c0.1,0.3-0.1,0.5-0.4,0.6l-20.5,5H100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.7,17c-0.2,0-0.4-0.2-0.5-0.4c-0.1-0.3,0.1-0.5,0.4-0.6l2.7-0.7c0.3-0.1,0.6,0.1,0.6,0.4 c0.1,0.3-0.1,0.6-0.4,0.6l-2.7,0.7C123.8,17,123.7,17,123.7,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.3,124.7l42.5-10.5c3.8-0.9,7.5,1.3,8.5,5.1l0.7,3.1c0.9,3.8-1.3,7.5-5.1,8.5l-42.5,10.5 c-3.8,0.9-7.5-1.3-8.5-5.1l-0.7-3.1C111.3,129.5,113.6,125.6,117.3,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.7,142.2c-3.5,0-6.5-2.3-7.3-5.7l-0.7-3.1c-1-4.1,1.4-8.1,5.5-9.2l42.6-10.5c4.1-1,8.1,1.4,9.1,5.5l0,0 l0.7,3.1c1,4.1-1.4,8.1-5.5,9.1l0,0l-42.6,10.4C120.9,142.1,120.3,142.2,119.7,142.2z M161.6,114.6c-0.5,0-1,0.1-1.5,0.2 l-42.6,10.4c-3.5,0.8-5.6,4.4-4.8,7.8l0,0l0.7,3.1c0.8,3.5,4.4,5.6,7.8,4.8l42.6-10.5c3.5-0.8,5.6-4.4,4.8-7.8l-0.7-3.1 C167.1,116.6,164.5,114.6,161.6,114.6L161.6,114.6z M163.9,131L163.9,131z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 85.1,
    transform: "matrix(0.971 -0.239 0.239 0.971 -17.7776 33.9993)",
    className: "st1",
    width: 57.8,
    height: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 109.7,
    cy: 96,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 116.2,
    cy: 94.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 122.6,
    cy: 92.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 128.9,
    cy: 91.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 101.5,
    transform: "matrix(0.971 -0.239 0.239 0.971 -21.5758 35.4547)",
    className: "st1",
    width: 57.8,
    height: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 113.7,
    cy: 112.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 120.1,
    cy: 110.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 126.5,
    cy: 109.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 133,
    cy: 107.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 50.3,
    transform: "matrix(0.971 -0.239 0.239 0.971 -10.4093 31.1665)",
    className: "st1",
    width: 25.8,
    height: 16.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4,53.8c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-1.2-5c-0.9-3.7,1.3-7.4,5-8.3l0,0l0,0 c3.7-0.9,7.4,1.3,8.3,5.1l1.2,5c0.1,0.2-0.1,0.5-0.3,0.6l-12.5,3.1L115.4,53.8z M120.4,40.9c-0.5,0-0.9,0.1-1.4,0.2l0,0 c-3.2,0.8-5.2,4-4.4,7.2l0,0l1.1,4.5l11.6-2.9l-1.1-4.5C125.6,42.8,123.2,40.9,120.4,40.9z M118.9,40.6L118.9,40.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 122.8,
    cy: 56,
    r: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.9,
    y: 56.4,
    transform: "matrix(0.971 -0.239 0.239 0.971 -10.5788 31.2468)",
    className: "st3",
    width: 1.3,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128,78.9h-0.1h-0.2l-0.3-0.1c-8-1.3-15.4-5.2-21.1-11.1c-2.6-2.9-4.9-6.1-6.4-9.7c-0.9-1.9-1.6-4.1-2-6.2 c-0.1-0.5,0.1-1.1,0.7-1.2c0.4-0.2,0.9-0.4,1.4-0.7c2.1-1.1,3.9-3,4.7-5.3c0.6-1.7,0.6-3.6,0.1-5.2c-0.2-0.5,0.1-1,0.5-1.2h0.1 l3-1.4c1.2-0.5,2.5-1.1,3.9-1.6c2.6-1.2,5.5-1.9,8.5-2.3c2-0.2,4.2-0.4,6.2-0.5l3.3-0.2c0.5-0.1,0.9,0.2,1,0.7l0,0l0.1,0.4 c0.1,0.5,0.3,1,0.5,1.5c0.9,2,2.6,3.7,4.7,4.5c1.6,0.6,3.5,0.9,5.2,0.7c0.6-0.1,1.3,0.3,1.4,1c0,0,0,0,0,0.1 c0.9,3.4,1.2,6.8,1,10.3c-0.5,9.4-4.5,17.6-11.7,24.5c-0.8,0.7-1.6,1.4-2.3,2l-1.1,0.9c-0.1,0.1-0.1,0.1-0.2,0.1L128,78.9L128,78.9 z M128.5,78.3L128.5,78.3z M105.7,39.1c0.6,1.9,0.5,4-0.1,5.9c-0.9,2.5-2.7,4.6-5.2,5.8c-0.5,0.3-1,0.5-1.5,0.8c0,0-0.1,0-0.1,0.1 c0.5,2,1.1,4.1,2,6c1.5,3.5,3.7,6.6,6.3,9.4c5.5,5.7,12.7,9.5,20.6,10.7c0.1,0,0.3,0.1,0.4,0.1h0.1h0.2l1-0.9 c0.8-0.6,1.6-1.3,2.3-2c7-6.7,10.9-14.7,11.4-23.7c0.2-3.4-0.1-6.7-1-9.9c0-0.1,0-0.2-0.1-0.2l0,0c-0.1,0-0.2,0-0.3,0 c-1.9,0.2-3.9-0.1-5.7-0.8c-2.3-0.9-4.3-2.7-5.3-5.1c-0.2-0.5-0.4-1.1-0.5-1.6l-0.1-0.4l-3.3,0.3c-2,0.2-4.2,0.3-6.1,0.5 c-2.9,0.3-5.5,1.1-8.1,2.2c-1.3,0.5-2.5,1.1-3.9,1.6C107.7,38.2,106.7,38.6,105.7,39.1L105.7,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70,176.8c0,0,8-67.5,16-74.9c9.4-8.8,18-14.8,19.5-9.7c1.5,5,3.1,13.3-9.9,22.7l1.8,16.7 c0,0,12.6,8.8,6.1,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70,177.3L70,177.3c-0.3,0-0.5-0.3-0.5-0.5c0.3-2.7,8.1-67.8,16.1-75.1c9.1-8.5,15.3-12.4,18.3-11.6 c1,0.3,1.7,1,1.9,2c3.6,11.4-3.3,18.3-9.8,23.1l1.8,16.2c1.6,1.2,12.3,10.6,6.1,36.7c-0.1,0.2-0.3,0.4-0.5,0.3l0,0 c-0.2-0.1-0.4-0.3-0.3-0.6c6.4-27-5.7-35.7-5.9-35.8c-0.1-0.1-0.2-0.2-0.2-0.3L95.2,115c0-0.2,0.1-0.3,0.2-0.4 c12-8.8,11.4-16.5,9.7-22.3c-0.1-0.7-0.6-1.2-1.3-1.4c-2.6-0.7-8.9,3.4-17.4,11.4c-7.7,7.2-15.8,73.9-15.9,74.6 C70.4,177.1,70.2,177.3,70,177.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "29.9,221.9 60.9,184.3 124.8,212.6 106,254.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 59.7,
    y1: 196.6,
    x2: 107.9,
    y2: 221.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.8,208.7c0,0-24-47.3-42.2-68.6c-2.4-3-5.6-3.4-7.8-1.9c-2.6,1.7-2.7,7.7-2.7,7.7s-6.9-4-10.2-3.2 s-3.7,6-3.7,6s-7.3-2.4-10.3,0.2c-3,2.6-3.1,7.3-3.1,7.3s-38.8-31.2-43-33.8c-4.3-2.6-11.9,2-8.1,7.5c2.3,3.5,21.9,22.9,28.2,29.1 c6.3,6.2,21.1,23,22.7,27.9c1.6,4.9,3.1,10.6-7,11.3s-18.9,2.4-23.4,6.2c-4.4,3.8-7.3,9.4-5.1,10.5s37.7-3,51.2,2.5 c13.5,5.5,31.1,25.7,31.1,25.7L267.8,208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.2,243.7L234.2,243.7c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-17.6-20.1-30.9-25.5c-9.3-3.8-29.2-3-41.1-2.5 c-6.4,0.2-9.3,0.3-10.1,0c-0.6-0.3-1-0.9-1-1.5c-0.3-2.3,2.4-6.7,6-9.8c4-3.4,12-5.5,23.7-6.3c3.6-0.2,5.9-1.1,6.9-2.7 c1.3-2,0.5-5-0.4-7.8c-1.6-4.8-16-21.3-22.6-27.7s-26-25.8-28.3-29.2c-1.6-2-1.4-5,0.4-6.8c1.9-2,5.7-3.1,8.5-1.4 c4,2.4,36.7,28.7,42.3,33.2c0.2-2.5,1.3-5,3.2-6.7c2.7-2.3,8.5-1,10.3-0.5c0.2-1.5,1-5.2,4-5.9s7.9,1.8,9.9,2.9 c0.1-1.7,0.7-5.8,3-7.3c2.6-1.7,6-1,8.6,1.9c17.9,21.1,42.1,68.3,42.3,68.7c0.1,0.2,0.1,0.4-0.1,0.6l-33.6,34.5 C234.6,243.7,234.4,243.7,234.2,243.7z M177.9,214.1c9.6,0,19.7,0.6,25.6,3.1c12.5,5.1,28.2,22.3,30.9,25.4l32.9-33.9 c-2.1-4.3-24.8-48.2-41.9-68.2c-2.1-2.5-5-3.3-7.1-1.8c-1.9,1.3-2.4,5.7-2.5,7.3c0,0.2-0.1,0.3-0.3,0.4s-0.4,0.1-0.5,0 c-0.1,0-6.7-3.9-9.8-3.1c-2.9,0.7-3.3,5.5-3.3,5.6c0,0.3-0.3,0.5-0.5,0.5h-0.1c-0.1,0-7.1-2.3-9.9,0.1c-2.7,2.4-3,6.9-3,7 c0,0.2-0.1,0.4-0.3,0.4c-0.2,0.1-0.4,0.1-0.5-0.1c-0.4-0.3-38.7-31.2-43-33.7c-2.3-1.4-5.5-0.4-7.1,1.3c-1.5,1.5-1.6,3.9-0.3,5.6 c2.3,3.4,21.7,22.7,28.2,29c5.9,5.8,21.1,22.9,22.8,28.1c1,3.1,1.9,6.3,0.3,8.8c-1.2,1.8-3.8,3-7.7,3.2 c-11.5,0.8-19.2,2.9-23.1,6.1c-3.6,3.1-5.9,7.1-5.7,8.9c0,0.3,0.2,0.6,0.4,0.7c0.6,0.3,5,0.1,9.6-0.1 C166.5,214.4,172.1,214.1,177.9,214.1L177.9,214.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "264.2,195 215.3,234.9 239.7,270.8 296.1,223.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 27.5,
    className: "st1",
    width: 62.7,
    height: 46.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.2,74.4h-62.6c-0.3,0-0.5-0.2-0.5-0.5V27.5c0-0.3,0.2-0.5,0.5-0.5h62.7c0.3,0,0.5,0.2,0.5,0.5v46.3 C256.8,74.1,256.5,74.4,256.2,74.4z M194,73.3h61.6V28.1h-61.7L194,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M246.4,42.3c-0.2,0.3-0.4,0.6-0.6,0.8l-21.7,21.6c-0.4,0.6-1.1,0.7-1.7,0.4c-0.2-0.1-0.3-0.2-0.4-0.4 l-12.1-12.6c-0.5-0.4-0.6-1.1-0.2-1.6c0.1-0.1,0.2-0.2,0.3-0.3l3.1-2.7c0.4-0.5,1.1-0.6,1.6-0.2c0.1,0.1,0.1,0.1,0.2,0.2l7.2,7.3 c0.4,0.6,1.1,0.7,1.7,0.4c0.2-0.1,0.3-0.2,0.4-0.4L241,38c0.4-0.5,1.1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3 c0.9,0.9,1.9,1.9,2.9,2.9c0.2,0.3,0.4,0.5,0.6,0.8V42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.9,99.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5c5.3-0.5,9.5-2.6,12.4-6.4c6.7-8.7,4.6-23.1,4.6-23.3 c0-0.3,0.1-0.5,0.4-0.6l0,0c0.3,0,0.5,0.2,0.6,0.4c0.1,0.6,2.2,15.1-4.8,24C203,96.4,198.6,98.6,192.9,99.2L192.9,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.6,226.3c-0.1,0-0.1,0-0.2,0l-53.1-24.8c-0.3-0.1-0.4-0.4-0.3-0.6c0.1-0.3,0.4-0.4,0.6-0.3 c0,0,0.1,0,0.1,0.1l53.1,24.8c0.3,0.1,0.4,0.4,0.2,0.7l0,0C110,226.2,109.8,226.3,109.6,226.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.6,241.4c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l42.1-32.2c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7l-42.2,32.2C225.9,241.4,225.7,241.4,225.6,241.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationFlatline2);
export default __webpack_public_path__ + "static/media/Authentication_Flatline-2.3ac179dd2eaacd11e26ea08e6a993ed8.svg";
export { ForwardRef as ReactComponent };